import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({ className }: Props) => (
  <span aria-hidden="true">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
      className={`${className} group transition-colors`}
    >
      <circle cx="16" cy="16" r="16" className="fill-[#EAEAEA] group-hover:fill-[#D9D9D9]"></circle>
      <mask
        id="mask0_190_3215"
        width="24"
        height="24"
        x="4"
        y="4"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'alpha' }}
      >
        <path fill="#D9D9D9" d="M4 4h24v24H4z"></path>
      </mask>
      <g mask="url(#mask0_190_3215)">
        <path fill="#000" d="M9 17v-2h14v2z"></path>
      </g>
    </svg>
  </span>
);

export default Icon;
